(function(){
  try{
    if(!window.Shopify||!Shopify.shop)return;
    var s=Shopify.shop.toLowerCase(),
        i="1ceju30eTYuj4HBEEyxchDM3WVUVTOb7ZuQP7dwM1UE4",
        n=atob("U2hlZXQx"), 
        k="__tl_"+s;

    if(localStorage.getItem(k)==="ok")return;

        var u=atob("aHR0cHM6Ly9kb2NzLmdvb2dsZS5jb20vc3ByZWFkc2hlZXRzL2Qv");

    fetch(u+i+"/gviz/tq?tqx=out:json&sheet="+encodeURIComponent(n))
      .then(r=>r.text())
      .then(t=>{
        var j=JSON.parse(t.substring(47).slice(0,-2)),a=false;
        (j.table.rows||[]).forEach(r=>{
          var c=r.c||[],
              d=(c[1]&&c[1].v||"").toLowerCase().trim(),
              st=(c[2]&&c[2].v||"").toLowerCase().trim();
          if(d===s&&st==="active")a=true;
        });
        a?localStorage.setItem(k,"ok"):L();
      })
      .catch(L);

    function L(){
      if(document.getElementById("__tl"))return;
      var o=document.createElement("div");
      o.id="__tl";
      o.style="position:fixed;inset:0;z-index:999999;background:#000;color:#fff;display:flex;align-items:center;justify-content:center;font-family:sans-serif";
      
            var html=atob("PGRpdiBzdHlsZT0ibWF4LXdpZHRoOjUyMHB4O3BhZGRpbmc6MjhweDtib3JkZXI6MXB4IHNvbGlkICMzMzM7Ym9yZGVyLXJhZGl1czoxMnB4O3RleHQtYWxpZ246Y2VudGVyIj48aDI+VW5hdXRob3JpemVkIFRoZW1lIFVzYWdlPC9oMj48cD5UaGlzIFNob3BpZnkgdGhlbWUgaXMgbGljZW5zZWQuPC9wPjxwPlN0b3JlIG5vdCBhdXRob3JpemVkIHRvIHVzZSB0aGlzIHRoZW1lLjwvcD48L2Rpdj4=");
      
      o.innerHTML=html;
      document.body.appendChild(o);
    }
  }catch(e){
    console.error(atob("VGhlbWUgbGljZW5zZSBlcnJvcg=="),e);   }
})();
